import React from 'react';
import ListAccountCards from './ListAccountCards';
import ListUserCards from './ListUserCards';


const ContactInfo = (props) => {

  if (props.didMount !== true) {
    return null;
  }
  if (props.showContactInfo === false) {
    return null;
  }
  if (props.contactCards.userContact === undefined) {
    return (
      <div>
        Contact info not found.
      </div>
    )
  }
  

  return (
    <div>
      <ListUserCards
        contactCards={props.contactCards.userContact}
      />
      <ListAccountCards
        contactCards={props.contactCards.accountContact}
      />
    </div>
  );
}

export default ContactInfo;



// WEBPACK FOOTER //
// ./src/containers/Contacts/ContactInfo.js